"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadataUrl = getMetadataUrl;
exports.resolveUrl = resolveUrl;
/**
 * Returns the URL of the metadata file given the URL of the micro frontend.
 */
function getMetadataUrl(mfUrl) {
    const metadataPath = "public/metadata.json";
    const lastIndex = mfUrl.lastIndexOf("/");
    if (lastIndex === -1) {
        return metadataPath;
    }
    return mfUrl.substring(0, lastIndex + 1) + metadataPath;
}
/**
 * Resolves a relative or absolute URL to an absolute URL
 */
function resolveUrl(url) {
    if (url.startsWith("http"))
        return url;
    const relativePath = url.startsWith(".") ? url.slice(1) : url;
    return location.origin + relativePath;
}
